<div class="container-fluid" cdkDropListGroup>
  <div class="content row mt-5">
    <!-- Document repository -->
    <div class="doc-repo col-xs-12 col-md-4 col-xl-4">
      <app-document-repository></app-document-repository>
    </div>
    <!-- Submenu panel -->
    <div class="submenu col-xs-12 col-sm-12 col-md-8">
      <div class="header row mb-4">
        <div
          class="competition-admin-header col-xs-12 col-sm-12 col-md-12 col-xl-6"
        >
          <i
            [hidden]="editMode"
            title="Edit competition"
            class="icon icon-btn-create-cover"
            (click)="onEdit()"
          ></i>
          <i
            [hidden]="!editMode"
            title="Cancel edit"
            class="icon icon-btn-cancel"
            (click)="onCancel()"
          ></i>
          <div class="col-12">
            <app-dropdown-menu
              *ngIf="!editMode"
              [options]="options"
              [selected]="selected"
              (select)="onSelectCompetition($event)"
            ></app-dropdown-menu>
            <div class="ml-4 edit-container" *ngIf="editMode">
              <label class="ml-4 mt-2">Display name</label>
              <input
                class="form-control"
                (keydown.enter)="onSaveEdit()"
                [placeholder]="competition.displayName"
                type="text"
                [(ngModel)]="newCompetitionName"
              />
            </div>
            <div class="ml-4 edit-container" *ngIf="editMode">
              <label class="ml-4 mt-2">URL</label>
              <input
                class="form-control"
                (keydown.enter)="onSaveEdit()"
                [placeholder]="competition.compUrl"
                type="text"
                [(ngModel)]="newCompetitionUrl"
                (change)="urlChanged()"
              />
            </div>
            <div class="ml-4 edit-container" *ngIf="editMode">
              <label class="ml-4 mt-2">Custom title (leave empty to hide title)</label>
              <input
                class="form-control"
                (keydown.enter)="onSaveEdit()"
                [placeholder]="competition.custom_title !== undefined ? competition.custom_title : 'e.g. UC3'"
                type="text"
                [(ngModel)]="newCompetitionCustomTitle"
              />
            </div>
            <div class="ml-4 mt-3 col-12" *ngIf="editMode">
              <input
                inputFocus
                class="col-1"
                type="checkbox"
                [(ngModel)]="competition.is_public"
                [attr.placeholder]="'Is competition public'"
                [checked]="competition.is_public"
              />
              <span class="title col-11">Is competition public</span>
            </div>
            <div class="ml-4 mt-3 col-12" *ngIf="editMode">
              <input
                inputFocus
                class="col-1"
                type="checkbox"
                [(ngModel)]="competition.hide_uptop_logo"
                [attr.placeholder]="'Hide UPTOP logo'"
                [checked]="competition.hide_uptop_logo"
              />
              <span class="title col-11">Hide UPTOP logo</span>
            </div>
            <div class="ml-4 mt-4" *ngIf="editMode">
              <app-competition-logo
                #lgcompetition
                [competition]="competition"
                (fileError)="onFileError($event)"
              ></app-competition-logo>
            </div>
            <div class="ml-4 mt-4 mb-4" *ngIf="editMode">
              <app-competition-background
                #bgcompetition
                [competituonUploaderType]="'background'"
                [competition]="competition"
                (fileError)="onFileError($event)"
              ></app-competition-background>
            </div>
            <div class="ml-4 mt-4 mb-4" *ngIf="editMode">
              <app-competition-background
                #ftcompetition
                [competituonUploaderType]="'footer'"
                [competition]="competition"
                (fileError)="onFileError($event)"
              ></app-competition-background>
            </div>
            <div class="ml-4 edit-container mt-4 mb-4" *ngIf="editMode">
              <button
                type="button"
                class="btn new-comp border-0 mr-2"
                (click)="onSaveEdit()"
              >
                <span>SAVE CHANGES</span>
              </button>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-xl-6" *ngIf="!editMode">
          <button type="button" class="btn preview mr-2" (click)="onPreview()">
            <span>PREVIEW</span>
          </button>
          <button
            type="button"
            class="btn new-comp border-0 mr-2"
            (click)="onNewCompetition()"
          >
            <span>CREATE</span>
          </button>
          <button
            type="button"
            class="btn new-comp border-0 mr-2"
            (click)="onDeleteCompetition()"
          >
            <span>DELETE</span>
          </button>
        </div>
      </div>
      <div class="submenu-items row">
        <app-submenu></app-submenu>
      </div>
      <div class="submenu-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
